import { useState, useEffect, createRef } from 'react';

import {
  IconButton,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Grid
} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import { useParams } from 'react-router-dom';

import { useStyles } from './ticket.styles';
import { BackdropComponent } from '../commons/backdrop/backdrop.component';
import { getSale } from '../../services/sales.service';
import { getProducts } from '../../services/products.service';


export const TicketComponent = () => {

  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [sale, setSale] = useState();
  const [allProducts, setAllProducts] = useState([]);
  const [print, setPrint] = useState(false);
  const ref = createRef(null);

  const classes = useStyles();

  const fetchSale = async (saleId) => {
    const saleItem = await getSale(saleId);
    const productsItems = await getProducts();
    setAllProducts(productsItems);
    setSale(saleItem);
    setLoading(false);
  }

  const getProduct = (productId) => {
    return allProducts.find(product => product.id === productId);
  }

  const removeNavbar = () => {
    const navbar = document.getElementById('navbar-frida');
    navbar.parentElement?.removeChild(navbar);
  }

  useEffect(() => {
    fetchSale(id);
    removeNavbar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    setPrint(true);
    setTimeout(() => {
      window.print();
    }, 500);
  }

  window.onafterprint = () => {
    setPrint(false);
  }

  return loading ? (
    <BackdropComponent />
  ) : (
    <div className={classes.ticket} ref={ref}>
      <div className={classes.ticketItem}>
        <img src="https://cdn-icons-png.flaticon.com/512/2491/2491002.png" alt="Frida" width="40%" />
      </div>
      <div className={classes.ticketItem}>
        <Typography variant="h5" align="center">
          Frida
        </Typography>
      </div>
      <Divider />
      <div className={classes.ticketItem}>
        <Typography variant="h6" align="center">
          TEL 241 150 5689
        </Typography>
      </div>
      <Divider />
      <div className={classes.ticketItemBorder}>
        <Typography variant="body1" align="center">
          16 de septiembre #12A, Col Centro, Calpulalpan, Tlaxcala. CP 90200
        </Typography>
      </div>
      <div className={classes.ticketItemBorder}>
        <Typography variant="body1" align="center">
          Fecha: {sale.date}
        </Typography>
      </div>
      <div className={classes.ticketItemBorder}>
        <Typography variant="body1" align="center">
          Mesa: {sale.table}
        </Typography>
      </div>
      <Divider />
      <div className={classes.ticketItem}>
        <TableContainer style={{ width: '100%' }}>
          <Table aria-label="orders">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell}>Producto</TableCell>
                <TableCell className={classes.tableHeader} align="right">Cantidad</TableCell>
                <TableCell className={classes.tableHeader} align="right">Precio</TableCell>
                <TableCell className={classes.tableHeader} align="right">Importe</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sale.items.map(order => ({
                quantity: order.quantity,
                product: getProduct(order.product)
              })).map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tableCell} component="th" scope="row">
                    {row.product.name}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="right">{row.quantity}</TableCell>
                  <TableCell className={classes.tableCell} align="right">${row.product.price}</TableCell>
                  <TableCell className={classes.tableCell} align="right">${row.product.price * row.quantity}</TableCell>
                </TableRow>
              ))}
              {sale.extra ? (
                <TableRow>
                  <TableCell colSpan={4} align="right">Cargo extra: ${sale.extra}</TableCell>
                </TableRow>
              ) : null}
              <TableRow>
                <TableCell colSpan={4} align="right">Total: ${sale.total}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Divider />
      <div className={classes.ticketItem}>
        <Typography variant="overline" align="center">
          Gracias por su preferencia
        </Typography>
      </div>
      {!print && (
        <Grid container justifyContent="center" spacing={1}>
          <Grid item>
            <IconButton onClick={handlePrint} aria-label="print" size="medium">
              <PrintIcon fontSize="inherit" />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </div>
  )
}